/* Sound Medical: predictive search for the header search form (2026-10-16). No dependencies. */
(function () {
  'use strict';
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n); } catch (e) { return '$' + n.toFixed(2); }
  }
  function init(form) {
    if (form.dataset.smbReady) return;
    form.dataset.smbReady = '1';
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('.smb-search-results');
    var base = (form.getAttribute('data-search-url') || '/search').replace(/\/$/, '');
    var timer = null, ctrl = null, active = -1, lastQ = '';
    function items() { return Array.prototype.slice.call(box.querySelectorAll('[data-smb-item]')); }
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function setActive(i) {
      var list = items();
      list.forEach(function (el) { el.classList.remove('is-active'); el.removeAttribute('aria-selected'); });
      if (!list.length) { active = -1; return; }
      active = (i + list.length) % list.length;
      list[active].classList.add('is-active');
      list[active].setAttribute('aria-selected', 'true');
      list[active].scrollIntoView({ block: 'nearest' });
    }
    function searchUrl(q) { return base + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q); }
    function render(q, res) {
      var html = '';
      var prods = res.products || [], cols = res.collections || [], qs = res.queries || [];
      if (prods.length) {
        html += '<div class="smb-sr-group"><div class="smb-sr-heading">Products</div>';
        prods.forEach(function (p) {
          var min = parseFloat(p.price_min || p.price), max = parseFloat(p.price_max || p.price);
          var price = isNaN(min) ? '' : (min !== max ? 'From ' + money(min) : money(min));
          var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" loading="lazy" width="48" height="48">' : '<span style="width:48px;height:48px;flex:0 0 48px"></span>';
          html += '<a class="smb-sr-item" data-smb-item role="option" href="' + esc(p.url) + '">' + img + '<span class="smb-sr-title">' + esc(p.title) + '</span><span class="smb-sr-price">' + esc(price) + '</span></a>';
        });
        html += '</div>';
      }
      if (cols.length) {
        html += '<div class="smb-sr-group"><div class="smb-sr-heading">Collections</div>';
        cols.forEach(function (c) { html += '<a class="smb-sr-item" data-smb-item role="option" href="' + esc(c.url) + '"><span class="smb-sr-text">' + esc(c.title) + '</span></a>'; });
        html += '</div>';
      }
      if (qs.length) {
        html += '<div class="smb-sr-group"><div class="smb-sr-heading">Search suggestions</div>';
        qs.forEach(function (s) { html += '<a class="smb-sr-item" data-smb-item role="option" href="' + esc(searchUrl(s.text)) + '"><span class="smb-sr-text">' + (s.styled_text || esc(s.text)) + '</span></a>'; });
        html += '</div>';
      }
      if (!html) html = '<div class="smb-sr-empty">No matches for "' + esc(q) + '"</div>';
      html += '<a class="smb-sr-all" data-smb-item href="' + esc(searchUrl(q)) + '">See all results for "' + esc(q) + '"</a>';
      box.innerHTML = html;
      active = -1;
      open();
    }
    function fetchSuggest(q) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
        if (input.value.trim() !== q) return;
        render(q, (d && d.resources && d.resources.results) || {});
      }).catch(function () {});
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { if (ctrl) ctrl.abort(); close(); return; }
      if (q === lastQ && !box.hidden) return;
      lastQ = q;
      timer = setTimeout(function () { fetchSuggest(q); }, 250);
    });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active < 0 ? -1 : active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); window.location.href = items()[active].href; }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('submit', function () { close(); });
  }
  function boot() { document.querySelectorAll('form[data-smb-search]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
